import { EVENT_FIELDS } from '../../constants/analytics'

const extractMetaTags = (payload) => ({
  [EVENT_FIELDS.META_TITLE]: payload?.properties?.title
})

export { extractMetaTags }
